import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { Modal, Button } from "react-bootstrap";
import { createDeliveryForSell, getCouriersListApi, getServiceBoyList, sellList } from "../../Services/Operations/ProductAPI";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import "../../Styles/PurchaseReport.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const SellReport = () => {
  const [sells, setSells] = useState([]);
  const[courierList,setCourierList]=useState([])
  const [showModal, setShowModal] = useState(false);
  const [modal2,setModal2]=useState(false)
  const [selectedSell, setSelectedSell] = useState(null);
  const[serviceBoys,setServiceBoys]=useState([])
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const[inputFiled,setInputField]=useState(false)

  const[serviceType,setServiceType]=useState(0)
  const[pickupDateTime,setPickupDateTime]=useState("")
  const[dropoffDateTime,setDropoffDateTime]=useState("")
  const[pickupAddress,setPickupAddress]=useState("")
  const[deliveryAddress,setDeliveryAddress]=useState("")


  const[trackingNumber,setTrackingNumber]=useState("")
  const[expectedDeliveryDate,setExpectedDeliveryDate]=useState("")
  const[remarks,setRemarks]=useState("")


       const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 10;
      
      const indexOfLast = currentPage * itemsPerPage;
      const indexOfFirst = indexOfLast - itemsPerPage;
      
      const currentUsers = sells.slice(indexOfFirst, indexOfLast);


  const fetchServieBoys=async()=>{
              
        
                try {
                    const response = await getServiceBoyList(token)
                    console.log("serice boy  List: ", response);
                    setServiceBoys(response)
                    
                } catch (error) {
                    console.log(error);
                    
                }
            }


  const fetchCourierList=async()=>{
      try {
  
          const response=await getCouriersListApi(token)
  
          console.log("list",response);
          if(response.status===200){
              setCourierList(response.data)
          }
          
          
      } catch (error) {
          console.log(error);
          
      }
  }
  const fetchSellList = async () => {
      try {
        const response = await sellList(token);
        console.log("response : ",response)
        setSells(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };
  useEffect(() => {
  
    fetchServieBoys()
    fetchSellList();
    fetchCourierList()
  }, []);

  const handleViewDetails = (sell) => {
    setSelectedSell(sell);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedSell(null);
  };

  const handleAssignSubmit=async(empId,cmnId)=>{

    const data={
      pickupDateTime,
      pickupAddress,
      dropoffDateTime,
      deliveryAddress,
      employeeId:empId,
      commonuserId:cmnId,
      storeId:selectedSell.storeId,
      serviceType:"DELIVERY",
      sellId:selectedSell.id

    }
    console.log(data);
    
    try {
      const response=await createDeliveryForSell(data,token)
      console.log(response);
      if(response.status===200){
        toast.success("Service person assigned successfully")
        fetchSellList();
      }
    } catch (error) {
      console.log(error);
      toast.error("failed to assign service boy")
      
    }finally{
      setModal2(false)
      setSelectedSell(null)
      setInputField(false)
    }
  }

  const handleAssignCourierSubmit=async(id)=>{
    const data={
      sellId:selectedSell.id,
      courierDetails:{
      courierServiceId:id,
      trackingNumber,
      expectedDeliveryDate,
      remarks,
      deliveryCost:500,
      
    }}
    try {
       const response=await createDeliveryForSell(data,token)
      console.log(response);
      if(response.status===200){
        toast.success("Service courier assigned successfully")
        fetchSellList();
      }
      
    } catch (error) {
      console.log(error);
      toast.error("failed to assign courier")
      
    }finally{
      setModal2(false)
      setSelectedSell(null)
      setInputField(false)
    }
  }

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Sell Report</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sell Report
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Sell-all">
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{textAlign:"center"}}>ID</th>
                      
                        <th style={{textAlign:"center"}}>Order From</th>
                        <th style={{textAlign:"center"}}>Reference Number</th>
                        <th style={{textAlign:"center"}}>Sell Date</th>
                         <th style={{textAlign:"center"}}>Order by</th>
                        <th style={{textAlign:"center"}}>Grand Total</th>
                        <th style={{textAlign:"center"}}>Payable Amount</th>
                        <th style={{textAlign:"center"}}>Due Amount</th>
                        <th style={{textAlign:"center"}}>status</th>
                    
                        <th style={{textAlign:"center"}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers.map((sell,index) => (
                        <tr key={sell.id}>
                          <td>{indexOfFirst+index+1}</td>
                        
                          <td>{sell.orderFrom || "N/A"}</td>
                          <td>{sell.referenceNumber || "N/A"}</td>
                          <td>
                            {sell.sellDate
                              ? new Date(
                                  Number(sell.sellDate)
                                ).toLocaleDateString()
                              : "N/A"}
                          </td>
                          <td>{sell.storeOwnerName}</td>
                          <td>₹{sell.grandTotal}</td>
                           <td>₹{sell.sellPayments[0]?.payableAmount}</td>
                            <td>₹{sell.sellPayments[0]?.dueAmount}</td>

                          <td>
                           {!sell.assignmentType?
                            <button type="button" className="btn "style={{border:"1px solid blue"}}
                            onClick={()=>{setModal2(true);setSelectedSell(sell)}}
                            >Assign</button>
                          :
                          <p style={{fontWeight:"900"}}>{sell.assignmentType}</p>}
                          </td>
                          
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={() => handleViewDetails(sell)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                           
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                                  <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(sells.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(sells.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                </div>
              </div>
            </div>
          </div>
        </div>


                      {/* details modal */}
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Sell Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedSell && (
              <div>
                <p>
                  <strong>ID:</strong> {selectedSell.id}
                </p>
                
                <p>
                  <strong>Grand Total:</strong> ₹{selectedSell.grandTotal}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {selectedSell.assignmentType}
                </p>
                <p>
                  <strong>Sub Total:</strong> ₹{selectedSell.subTotal || "N/A"}
                </p>
                <p>
                  <strong>Payable Amount:</strong> ₹
                  {selectedSell.sellPayments[0]?.payableAmount || "N/A"}
                </p>
                <p>
                  <strong>Due Amount:</strong> ₹
                  {selectedSell.sellPayments[0]?.dueAmount|| "N/A"}
                </p>
                <p>
                  <strong>Payment Mode:</strong>{" "}
                  {selectedSell.sellPayments[0]?.paymentMode || "N/A"}
                </p>
                <div>
                  {selectedSell.assignmentType==="COURIER"?
                  <div>
                    <p style={{borderBottom:"1px solid grey"}}>Courier service details</p>
                    <p>Courier Name:{selectedSell?.courierDetails?.courierName}</p>
                    <p>Delivery cost:{selectedSell?.courierDetails?.deliveryCost}</p>
                    <p>Expected Delivery Date:{ new Date(
                                  Number(selectedSell.courierDetails?.expectedDeliveryDate)
                                ).toLocaleDateString()}</p>
                                  <p>Tracking Number:{selectedSell.courierDetails?.trackingNumber}</p>
                    </div>
                    :selectedSell.assignmentType==="SERVICE_PERSON"?<div>

                     <p style={{borderBottom:"1px solid grey"}}> Service boy details</p>

                            <p>Courier Name:{selectedSell.servicePersonAssign?.servicePersonName}</p>
                    <p>Delivery cost:{selectedSell.servicePersonAssign?.serviceType}</p>
                    <p>Pickup Address:{selectedSell.servicePersonAssign?.pickupAddress}</p>
                    <p>Pick up Date time:{selectedSell.servicePersonAssign?.pickupDateTime}</p>
                    <p>Delivery Address:{selectedSell.servicePersonAssign?.deliveryAddress}</p>
                    <p>Delivery Time:{selectedSell.servicePersonAssign?.dropoffDateTime}</p>
                      </div>

                      :<div>
                        Assign service courier
                      </div>
                
                }
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>


        {/* assign boy modal */}

         <Modal show={modal2} onHide={()=>setModal2(false)} size="lg">
          <Modal.Header closeButton>



            
            <p> select delivery type</p>

             <div style={{width:"100%",display:"flex",justifyContent:"center",gap:"10px"}}>
              <p style={{backgroundColor:serviceType===0?"#868686ff":"#dee0e0ff",color:serviceType===0?"#000":"#c2c2c2ff",
                padding:"5px",fontSize:"15px",borderRadius:"9px",cursor:"pointer"}}
                onClick={()=>setServiceType(0)}>
                Service Boy</p>
               <p style={{backgroundColor:serviceType===1?"#868686ff":"#dee0e0ff",color:serviceType===1?"#000":"#c2c2c2ff",
                padding:"5px",fontSize:"15px",borderRadius:"9px",cursor:"pointer"}}
                onClick={()=>setServiceType(1)}>
                Courier</p>
            </div>

          </Modal.Header>
          <Modal.Body>

            <p style={{borderBottom:"2px solid blue",padding:"6px",textAlign:"center",fontWeight:"700"}}>
              {serviceType===0?"Available Service boy":"Available courier service"}</p>

          
         {selectedSell &&  serviceType===0 ?
          serviceBoys.map(boy=>
             <div style={{borderRadius:"15px",padding:"10px",border:"2px solid gray",margin:"6px"}}>
                <p>
                  <strong>Name:</strong> {boy.firstName}
                </p>
                <p>
                  <strong>Building name:</strong> {boy.houseBuildingApartment || "N/A"}
                </p>
                <p>
                  <strong>Area Sector:</strong>{" "}
                  {boy.areaLocalitySector || "N/A"}
                </p>
                <p>
                  <strong>Post Office:</strong>{" "}
                  {boy.postOffice|| "N/A"}
                </p>
                  <p>
                  <strong>City/Village:</strong>{" "}
                  {boy.streetRoadLane|| "N/A"} , {boy.villageTownCity|| "N/A"}
                </p>
              
                <p>
                  <strong>District:</strong> {boy.district} , {boy.state}
                </p>
                <p>
                  <strong>Pincode:</strong>{" "}
                  {boy.pincode|| "N/A"}
                </p>

                 {
          inputFiled &&(
            <div style={{borderRadius:"10px",margin:"8px",padding:"6px",border:"1px solid black"}}>
              <label>
                Enter Pickup Date Time
              <input type="date" value={pickupDateTime} onChange={(e)=>setPickupDateTime(e.target.value)}/>
     
     
              </label>
              <label>
              Enter Pickup Address  
              <input type="text" value={pickupAddress} onChange={(e)=>setPickupAddress(e.target.value)}/>
              </label>
              <label>
                Enter Dropoff Date Time
                <input  type="date" value={dropoffDateTime} onChange={(e)=>setDropoffDateTime(e.target.value)}/>
              </label>
              <label>
                Enter DeliveryAddress
                <input type="text" value={deliveryAddress} onChange={(e)=>setDeliveryAddress(e.target.value)}/>
              </label>
            </div>
          )
        }

               {inputFiled? <p 
                style={{fontSize:"20px",fontWeight:"700",padding:"6px",borderRadius:"10px",cursor:"pointer",backgroundColor:"#517efaff",width:"fit-content"}}
                onClick={()=>handleAssignSubmit(boy.employeeId,boy.commonuserId)}
                >
                  Submit</p>
                  :
                  <p style={{fontSize:"20px",fontWeight:"700",padding:"6px",borderRadius:"10px",cursor:"pointer",backgroundColor:"#8bcafdff",width:"fit-content"}}
                  onClick={()=>setInputField(true)}
                  >
                    Assign
                  </p>
                }
                
              </div>)
              :
             selectedSell &&  serviceType===1?
              courierList.map(courier=>(
                <div style={{borderRadius:"15px",padding:"10px",border:"2px solid gray",margin:"6px"}}>
                    <p>
                  <strong>Name:</strong> {courier.courierServiceName}
                </p>
                <p>
                  <strong>Email:</strong> {courier.email || "N/A"}
                </p>
                <p>
                  <strong>Contact number:</strong>{" "}
                  {courier.contactNumber || "N/A"}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {courier.status===0?"Inactive":"Active"|| "N/A"}
                </p>
                  <p>
                  <strong>Address:</strong>{" "}
                  {courier.addressLine1|| "N/A"} , {courier.city|| "N/A"}
                </p>

                {
          inputFiled &&(
            <div style={{borderRadius:"10px",margin:"8px",padding:"6px",border:"1px solid black"}}>
              <label>
               Enter Tracking Number
      
      
              <input type="text" value={trackingNumber} onChange={(e)=>setTrackingNumber(e.target.value)}/>
     
     
              </label>
              <label>
              Enter Expected Delivery Date
              <input type="date" value={expectedDeliveryDate} onChange={(e)=>setExpectedDeliveryDate(e.target.value)}/>
              </label>
              <label>
               Enter Remarks
                <input  type="text" value={remarks} onChange={(e)=>setRemarks(e.target.value)}/>
              </label>
            
            </div>
          )
        }

                {inputFiled?<p 
                style={{fontSize:"20px",fontWeight:"700",padding:"6px",borderRadius:"10px",cursor:"pointer",backgroundColor:"#8bcafdff",width:"fit-content"}}
                onClick={()=>handleAssignCourierSubmit(courier.id)}
                >
                  Submit</p>:
                  <p 
                style={{fontSize:"20px",fontWeight:"700",padding:"6px",borderRadius:"10px",cursor:"pointer",backgroundColor:"#8bcafdff",width:"fit-content"}}
                onClick={()=>setInputField(true)}
                >
                  Assign</p>
                  }
                </div>
              )):""

              }
            
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>


        {
          inputFiled &&(
            <div>
              <label>
                Enter Pickup Date Time
              <input type="date" onChange={(e)=>setPickupDateTime(e.target.value)}/>
     
     
              </label>
              <label>
              Enter Pickup Address  
              </label>
              <label>
                Enter Dropoff Date Time
              </label>
              <label>
                Enter DeliveryAddress
              </label>
            </div>
          )
        }

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default SellReport;
